import { create } from "zustand";
import { Category } from "../data/Category";

type CategoryTabStore = {
    isShowOptions: boolean;
    selectedCategory: Category | undefined;
    openOptions: (c: Category | undefined) => void;
    closeOptions: () => void;
}

export const useCategoryTabStore = create<CategoryTabStore>((set) => ({
    isShowOptions: false,
    selectedCategory: undefined,
    openOptions: (c: Category | undefined) => {
        set(() => ({ selectedCategory: c }))
        setTimeout(() => set(() => ({ isShowOptions: true })), 100);
    },
    closeOptions: () => set(() => ({ isShowOptions: false, selectedCategoryId: undefined })),
}));